window.theme = window.theme || {};
window.eve = window.eve || {};

// UTIL
function isMobile(){
  return $(window).width() <= 1024;
}

// Mobile Drawer drawer-accordian
$('.drawer-accordian').click(function(e){
  if(isMobile()){
    e.preventDefault();
    $(this).next('ul').slideToggle();
    $(this).find('.icon-plus').eq(0).toggle();
    $(this).find('.icon-minus').eq(0).toggle();
  }
});

$(document).ready(function(){
  var heroSlider = $('.hero-slider');
  var quotesSlider = $('.quotes-slider');
  var featuresSlider = $('.feature-cards__slider');
  var featureCards = $('.feature-cards');
  var featureCard = $('.feature-card');
  var dropdownLink = $('.shop-link');
  var megaMenu = $('.mega-menu');
  var megaMenuTabs = $('.mega-menu__tabs a');
  var megaMenuLists = $('.mega-menu__list');
  var megaMenuImages = $('.mega-menu__image');
  var selectedTab = megaMenuTabs.eq(0).data('tab');
  var productAccordianHeader = $('.product__accordian--header');


  //use this to prevent display issues with initial slideDown
  megaMenu.css('display', 'flex').hide();

  heroSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    draggable: true,
    touchThreshold: 20,
    prevArrow: '<button class="slick-prev slick-arrow"></button>',
    nextArrow: '<button class="slick-next slick-arrow"></button>',
    autoplay: $('.hero-slider').data('autoplay'),
    autoplaySpeed: $('.hero-slider').data('speed')
  });

  quotesSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    draggable: true,
    touchThreshold: 20,
    prevArrow: '<button class="slick-prev slick-arrow"></button>',
    nextArrow: '<button class="slick-next slick-arrow"></button>',
    autoplay: $('.quotes-slider').data('autoplay'),
    autoplaySpeed: $('.quotes-slider').data('speed'),
    pauseOnHover: false
  });

  featuresSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    draggable: true,
    touchThreshold: 20,
    centerMode: true,
    centerPadding: 0,
    prevArrow: '<button class="slick-prev slick-arrow"></button>',
    nextArrow: '<button class="slick-next slick-arrow"></button>',
    autoplay: false
  });

  //Mega menu hover effects
  dropdownLink.hover(function(){
    if(!isMobile())
      setTimeout(function(){
        megaMenu.slideDown().css('display', 'flex');
      }, 400);
    }, function(){
      if(!isMobile()){
        setTimeout(function(){
          if (!megaMenu.is(':hover')){
            megaMenu.slideUp();
          }
        }, 200);
      }
  });

  megaMenu.mouseleave(function(){
    if(!isMobile()){
      setTimeout(function(){
        if (!$('.shop-link:hover').length > 0)
          megaMenu.slideUp();
      }, 200);
    }
  });

  //show first tab only
  megaMenuLists.hide();
  megaMenuImages.hide();
  megaMenuLists.filter('[data-tab="' + selectedTab + '"]').show();
  megaMenuImages.filter('[data-tab="' + selectedTab + '"]').fadeIn();
  megaMenuTabs.eq(0).addClass('active');

  //mega menu tabs
  megaMenuTabs.click(function(){
    megaMenuTabs.removeClass('active');
    $(this).addClass('active');
    selectedTab = $(this).data('tab');
    megaMenuLists.hide();
    megaMenuImages.hide();
    megaMenuLists.filter('[data-tab="' + selectedTab + '"]').show();
    megaMenuImages.filter('[data-tab="' + selectedTab + '"]').fadeIn();
  });

  //product custom field accordians
  productAccordianHeader.click(function(){
    $(this).siblings('.product__accordian--content').slideToggle();
    $(this).find('.icon').toggle();
  });


});

// ################################################################################################################
// INSTAFEED
// ################################################################################################################
created.instafeed = (function () {
  function runFeed(payload) {
    var feed = new Instafeed({
      get: 'user',
      userId: payload.userId,
      accessToken: payload.accessToken,
      link: 'true',
      limit: '6',
      resolution: 'standard_resolution',
      template: payload.template,
    })

    feed.run()
  }

  function init() {
    if (
        created.ig &&
        created.ig.userId &&
        created.ig.accessToken
    ) {
      runFeed({
        userId: created.ig.userId,
        accessToken: created.ig.accessToken,
        template: created.ig.template,
      })
    }
  }

  return {
    init: init,
  }
})()

// ################################################################################################################
// INIT
// ################################################################################################################
created.init = function () {
  created.header.init()
  created.nav.init()
  created.cart.init()
  created.instafeed.init()
  created.mobileSlider.init()
  created.collectionSlider.init()
  created.form.init()
}

$(created.init)
